import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SaveDraftItem } from '@shared/components';
import { ExperienceType } from '@shared/models/draft';
import { SaveDraftModalContent } from '@shared/services/content/content-jsons/save-draft-modal-content';
import { ButtonComponent } from '@vg-constellation/angular-16/button';
import { IconModule } from '@vg-constellation/angular-16/icon';
import { ModalDialogComponent } from '@vg-constellation/angular-16/modal-dialog';
import { SpinnerModule } from '@vg-constellation/angular-16/spinner';

@Component({
  selector: 'app-save-draft-modal',
  templateUrl: './save-draft-modal.component.html',
  styleUrls: ['./save-draft-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, ModalDialogComponent, ButtonComponent, IconModule, SpinnerModule],
})
export class SaveDraftModalComponent {
  @Input() public drafts: SaveDraftItem[] = [];
  @Input() public draftsLoading = false;
  @Input() public experienceType: ExperienceType = ExperienceType.NONE;
  @Output() public deleteDraft = new EventEmitter<SaveDraftItem>();
  @Output() public retrieveDraft = new EventEmitter<SaveDraftItem>();

  @ViewChild('saveDraftModal') saveDraftModal?: ModalDialogComponent;

  public content = SaveDraftModalContent;

  openModal(): void {
    this.saveDraftModal?.openModalDialog();
  }

  closeModal(): void {
    this.saveDraftModal?.closeDialogModal();
  }

  onDeleteDraft(draft: SaveDraftItem): void {
    this.deleteDraft.emit(draft);
  }

  onRetrieveDraft(draft: SaveDraftItem): void {
    this.retrieveDraft.emit(draft);
    this.closeModal();
  }
}
